import { AppDispatch, GetState } from '../store';
import { selectCurrentStep, Step } from '../slices/step.slice';
import { setBankProcessFinished } from '../slices/ui.slice';
import { initializeProcessingStep } from './init-current-step';

export const bankAppCompleted = () => {
	return (dispatch: AppDispatch, getState: GetState) => {
		const state = getState();
		const currentStep = selectCurrentStep(state);

		if (!isCurrentBankStep(currentStep)) return;

		dispatch(setBankProcessFinished());
		dispatch(initializeProcessingStep());
	};
};

const isCurrentBankStep = (step: Step) => {
	return step === 'BANK_STEP';
};
